import { render, staticRenderFns } from "./thirdPatrySubscription.vue?vue&type=template&id=07d9bcbf&"
import script from "./thirdPatrySubscription.vue?vue&type=script&lang=js&"
export * from "./thirdPatrySubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports